import { getTextColor, themeGet } from '@magalu/stereo-ui-styles';
import styled from 'styled-components';
import { Text as TextElement } from '../../atoms';
export const ProductShippingCost = styled(TextElement)`
  font-size: ${props => themeGet('fontSizes.0')(props)}px;
  color: ${getTextColor('scratched')};
  text-align: ${({
  textAlign
}) => textAlign};

  span {
    color: ${themeGet('palette.secondary.dark')};
    font-weight: ${themeGet('fontWeights.bold')};
  }
`;